export enum BuildingType {
  Land = 7,
  Other = 10
}
